import { render, staticRenderFns } from "./DistributeFilters.vue?vue&type=template&id=bf1fd4bc"
import script from "./DistributeFilters.vue?vue&type=script&lang=js"
export * from "./DistributeFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports